import React from "react";
import { ArrowRight } from "lucide-react";
import { SERVICE_GROUPS, servicesByGroup, buildWaLink, serviceMessage, trackWhatsApp } from "@/lib/services";

export default function HowCanWeHelp() {
  return (
    <section data-testid="help-section" id="how-we-help" className="py-16 md:py-24 bg-bone">
      <div className="container-x">
        <div className="max-w-2xl">
          <h2 className="text-[32px] md:text-[44px] font-extrabold text-navy">How can we help?</h2>
          <p className="mt-3 text-ink/85">Pick the kind of care your family needs. Every service is nurse-led and available across Bangalore.</p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICE_GROUPS.map((g) => {
            const items = servicesByGroup(g.key);
            return (
              <article key={g.key} data-testid={`group-${g.key}`} className="bg-white rounded-3xl overflow-hidden border border-navy/10 shadow-soft flex flex-col">
                <div className="aspect-[16/10] overflow-hidden bg-soft-blue">
                  <img src={g.image} alt={g.title} loading="lazy" className="w-full h-full object-cover" />
                </div>
                <div className="p-6 md:p-7 flex-1 flex flex-col">
                  <h3 className="text-[22px] md:text-[24px] font-bold text-navy">{g.title}</h3>
                  <p className="mt-2 text-ink/80 text-[15.5px] leading-relaxed">{g.short}</p>
                  <ul className="mt-4 space-y-1.5 flex-1">
                    {items.slice(0, 6).map((s) => (
                      <li key={s.slug}>
                        <a
                          data-testid={`group-link-${s.slug}`}
                          href={buildWaLink(serviceMessage(s.name))}
                          target="_blank" rel="noopener noreferrer"
                          onClick={() => trackWhatsApp(s.name)}
                          aria-label={`Chat on WhatsApp about ${s.name}`}
                          className="text-[14.5px] text-ink hover:text-brand"
                        >
                          · {s.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                  <a href="/services" className="mt-6 inline-flex items-center gap-1.5 text-brand font-bold hover:gap-2.5 transition-all">
                    View services <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
